import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class WebshopService {

  constructor(
    private api: ApiService
  ) { }

  public getBrands(): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/active-setup-brands`, `webshop`)
    return rtn;
  }

  public getBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}`, `webshop`)
    return rtn;
  }

  public getTenantByID(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/tenant/${id}`, `webshop`)
    return rtn;
  }

  public getOutletsByBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/outlets`, `webshop`)
    return rtn;
  }

  public createTheme(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/theme`, data, `webshop`)
    return rtn;
  }

  public getThemForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/theme`, `webshop`)
    return rtn;
  }

  public updateTheme(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/theme`, data, `webshop`)
    return rtn;
  }

  public createSeoType(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/seotype`, data, `webshop`)
    return rtn;
  }

  public getSeoTypes(): Observable<any> {
    var rtn = this.api.get(`/api/v1/seotype`, `webshop`)
    return rtn;
  }

  public updateSeoType(id: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/seotype/${id}`, data, `webshop`)
    return rtn;
  }

  public updateSeoDetailsByBrand(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/seodetail/${id}`, data, `webshop`)
    return rtn;
  }

  public createSeoDetails(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/seodetail`, data, `webshop`)
    return rtn;
  }

  public getSeoByBrand(id: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/seo?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public createLink(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/link`, data, `webshop`)
    return rtn;
  }

  public getAllLinks(): Observable<any> {
    var rtn = this.api.get(`/api/v1/link`, `webshop`)
    return rtn;
  }

  public getLinkByTenantId(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/linkbytenant/${id}`, `webshop`)
    return rtn;
  }

  public getLinkByBrandId(brandId: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${brandId}/link?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public updateLink(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/link`, data, `webshop`)
    return rtn;
  }

  public createMetadata(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/metadata`, data, `webshop`)
    return rtn;
  }

  public getMetadata(): Observable<any> {
    var rtn = this.api.get(`/api/v1/metadata`, `webshop`)
    return rtn;
  }

  public getMetadataByBrand(id: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/metadata?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public updateMetadata(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/metadata`, data, `webshop`)
    return rtn;
  }

  public deleteMetadata(id: any,): Observable<any> {
    var rtn = this.api.delete(`/api/v1/metadata/${id}`, `webshop`)
    return rtn;
  }

  public createFaviconForBrand(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/favicon/link`, data, `webshop`)
    return rtn;
  }

  public getFaviconForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/favicon`, `webshop`)
    return rtn;
  }

  public updateFaviconByBrand(favId: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/favicon/${favId}`, data, `webshop`)
    return rtn;
  }

  public saveSearchBar(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/searchbar`, data, `webshop`)
    return rtn;
  }

  public getSearchBarByBrand(id: any, outletId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/searchbar?outlet_id=${outletId}`, `webshop`)
    return rtn;
  }

  public updateSearchByBrand(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${id}/searchbar`, data, `webshop`)
    return rtn;
  }

  public createPromotion(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/promotion`, data, `webshop`)
    return rtn;
  }

  public getPromotionByBrand(id: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/promotion?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public updatePromotionByBrand(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${id}/promotion`, data, `webshop`)
    return rtn;
  }

  public createMobileApp(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/mobileapp`, data, `webshop`)
    return rtn;
  }

  public updateMobileApp(mobileID: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/mobileapp/${mobileID}`, data, `webshop`)
    return rtn;
  }

  public getMobileAppForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/mobileapp`, `webshop`)
    return rtn;
  }

  public createRestaurant(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/restaurant`, data, `webshop`)
    return rtn;
  }

  public getRestaurantForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/restaurant`, `webshop`)
    return rtn;
  }

  public updateRestaurantByBrandId(brandID: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${brandID}/restaurant`, data, `webshop`)
    return rtn;
  }

  public createBasicInfo(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/basicinfo`, data, `webshop`)
    return rtn;
  }

  public getBasicInfoForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/basicinfo`, `webshop`)
    return rtn;
  }

  public updateBasicInfo(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/basicinfo/${id}`, data, `webshop`)
    return rtn;
  }

  public getHasMultiShop(id: any,): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/has-multishop`, `webshop`)
    return rtn;
  }

  public updateHasMultiShop(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${id}/has-multishop`, data, `webshop`)
    return rtn;
  }

  public createHomePage(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/homepage`, data, `webshop`)
    return rtn;
  }

  public updateHomePageByBrandId(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${id}/homepage`, data, `webshop`)
    return rtn;
  }

  public getHomePageForBrand(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/homepage`, `webshop`)
    return rtn;
  }

  public createTemplate(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/template`, data, `webshop`)
    return rtn;
  }

  public getContactUsData(id: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/contact-us?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public getFooterDataByBrandID(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/footer`, `webshop`)
    return rtn;
  }
  public createFooterData(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/footer`, data, `webshop`)
    return rtn;
  }

  public getSocialLinksByBrand(id: any, shopId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}/social-link?outlet_id=${shopId}`, `webshop`)
    return rtn;
  }

  public saveSocialLinks(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/sociallink`, data, `webshop`)
    return rtn;
  }

  public getAllBrands(): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand`, `webshop`)
    return rtn;
  }

  public getAllBrandPagination(nextPage: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand?page=${nextPage}`, `webshop`)
    return rtn;
  }

  public getBrandById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${id}`, `webshop`)
    return rtn;
  }

  public addBrand(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/brand`, data, `webshop`)
    return rtn;
  }

  public updateBrand(id: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/brand/${id}`, data, `webshop`)
    return rtn;
  }

  public deleteBrand(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/brand/${id}`, `webshop`)
    return rtn;
  }

  public brandSetUp(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${id}/setup-status`, data, `webshop`)
    return rtn;
  }

  public brandDuplicate(brandId: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/brand/duplicate/${brandId}`, data, `webshop`)
    return rtn;
  }

  public orderMethodsAdd(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/homepage/order-methods`, data, `webshop`)
    return rtn;
  }

  public getAllOrderMethods(brandId: any, outletId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${brandId}/outlet/${outletId}/order-methods`, `webshop`)
    return rtn;
  }

  public addMainSection(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/homepage/main-section`, data, `webshop`)
    return rtn;
  }

  public getMainSection(brandId: any, outletId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop-brand/${brandId}/outlet/${outletId}/homepage/main-section`, `webshop`)
    return rtn;
  }

  public updateDefaultShop(brandID: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/webshop-brand/${brandID}/default-shop`, data, `webshop`)
    return rtn;
  }
}
